interface ContractTypeData {
  id?: number;
  name?: string;
  description?: string;

  translations?: any;
}

export class ContractType {
  public static readonly ID_NOT_SPECIFIED: number = 1;
  public static readonly ID_DEFAULT: number = ContractType.ID_NOT_SPECIFIED;

  public static getNonTranslatableFields(): string[] { return ['id']; }
  public static getTranslatableFields(): string[] { return ['name', 'description']; }
  public static getFields(): string[] { return ['id', 'name', 'description']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  description?: string;

  translations?: any;

  public static fromAPI(data: ContractTypeData) {
    let translationData: any = {};
    if (data.translations) {
      for (let i = 0; i < data.translations?.length; i++) {
        if (data.translations[i]['contractTypeId'] === data['id']) {
          translationData = data.translations[i];
          i = data.translations?.length;
        }
      }
    }
    return new ContractType({
      id: data.id,
      name: translationData.name ?? data.name,
      description: translationData.description ?? data.description,
      translations: data.translations
    });
  }

  public static fromAPIList(data: ContractTypeData[]) {
    return data.map((item: ContractTypeData) => ContractType.fromAPI(item));
  }

  constructor({id, name, description, translations} : ContractTypeData) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.translations = translations;
  }

  public toJson(): Object {
    return {
      id: this.id,
      name: this.name,
      description: this.description
    };
  }
}
